export const MAX_SESSION_MS = 10 * 60 * 1000;
export const PRE_TIMEOUT_WARNING_MS = 3 * 60 * 1000;
export const MIN_SUMMARISE_CHARS = 80;
export const MAX_SUMMARISE_UI_CHARS = 4000;
export const MAX_SUMMARISE_INPUT_CHARS = 4000;
export const SESSION_STORAGE_LIMIT_INFO_KEY = "stt-limit-info-seen";
export const LIMIT_INFO_DISMISS_MS = 5000;

export const formatCountdownMmSs = (remainingMs: number): string => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};
